/*
 * Created by: cparaschiv
 * Date: 27.05.2013, 17:40
 */

TS.ObjectFactory = TS.ObjectFactory || {};

(function () {
    'use strict';

    var typeMap = {};
    var uids = {};

    /**
     * @exports TS.ObjectFactory
     * @desc
     * <p>Creates class instances based on a type moniker (string) and a JSON config.
     * The purpose is to defer object instantiation.</p>
     *
     */
    var ObjectFactory = {
        /**
         * Creates an instance of a class by its alias, using the provided configuration.
         * @param type {String} A type alias.
         * @returns {Object}
         * @static
         *
         * @example
         * var json = {
         *   firstName: 'John',
         *   lastName: 'Doe',
         *   ...
         *   propertyType: 'person'
         * };
         *
         * var p = TS.ObjectFactory.createObject(json);
         * // equivalent to
         * var p = new Person(json);
         */
        createObject: function (type) {
            var ctor, ret, uid;

            if (!type)
                throw new RangeError('A valid type must be supplied. Supplied value: [' + type + ']');

            ctor = typeMap[type];

            if (!ctor)
                throw new Error('Cannot find constructor for type [' + type + ']');

            if (!uids[type]) {
                uids[type] = -1;
            }
            uid = uids[type];
            uid++;

            var args = Array.prototype.slice.call(arguments, 1);
            args.splice(0, 0, ctor);
            ctor = ctor.bind.apply(ctor, args);
            ret = new ctor();
            ret.uid = uid;
            return ret;
        },

        /**
         * Maps a type alias to a concrete constructor.
         * @param type {String} Type alias.
         * @param ctor {Function} Actual constructor function.
         * @static
         *
         * @example
         *
         * var Person = new Class(...);
         * TS.ObjectFactory.map('person', Person);
         */
        map: function (type, ctor) {
            typeMap[type] = ctor;
        }
    };

    TS.ObjectFactory = ObjectFactory;

})();